module.exports = __webpack_public_path__ + "static/img/diamante-risco.1676fe8e.png";